import { ReactElement, useState } from 'react';
import { Link } from 'react-scroll';

import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import { Theme, useTheme, Popover, Box, Button } from '@mui/material';

import { NavItemProps, Event } from './types';

import { Anchor } from '../../types';
import ListItem from '../ListItem';

export default function NavItem({ children, color, label }: NavItemProps): ReactElement {
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState<Anchor>(null);

  return (
    <>
      <Box
        onClick={(event: Event) => setAnchorEl(event.currentTarget)}
        sx={{
          'textDecoration': 'none',

          'transition': (theme: Theme) =>
            `${theme.transitions?.duration?.shortest}ms ${theme.transitions?.easing?.easeInOut}`,

          '& .MuiButton-text': {
            'color': `${color} !important`,

            'opacity': 1,

            'transition': (theme: Theme) =>
              `${theme.transitions?.duration?.shortest}ms ${theme.transitions?.easing?.easeInOut}`,

            '& .MuiSvgIcon-root': {
              color: `${color} !important`,
              typography: 'h6',

              ml: 1,

              transition: (theme: Theme) =>
                `${theme.transitions?.duration?.shortest}ms ${theme.transitions?.easing?.easeInOut}`
            },

            '&:hover': {
              'opacity': 0.5,

              'color': `${color} !important`,

              '& .MuiSvgIcon-root': {
                color: `${color} !important`
              }
            }
          }
        }}>
        <Button
          color='secondary'
          endIcon={
            children ? (
              <ChevronRightOutlinedIcon
                style={{
                  transform: anchorEl ? 'rotate(270deg)' : 'rotate(90deg)'
                }}
              />
            ) : null
          }
          size='medium'
          variant='text'
          sx={{ color: `${theme.palette.grey[50]} !important` }}>
          {label}
        </Button>
      </Box>

      {children ? (
        <Popover
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
          elevation={3}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          PaperProps={{
            sx: {
              zIndex: 1000,

              backgroundColor: 'background.default',
              borderRadius: 0,

              p: 0
            }
          }}
          sx={{
            '& *': {
              transition: (theme: Theme) =>
                `${theme.transitions?.duration?.shortest}ms ${theme.transitions?.easing?.easeInOut}`
            }
          }}>
          <Box
            sx={{
              width: '100%',

              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              justifyContent: 'stretch'
            }}>
            {children.map((child) => (
              <Link
                key={child.label}
                aria-label={`${child.label} nav-item`}
                to={child.to || ''}
                spy
                smooth
                offset={-99.19}>
                <Box onClick={() => setAnchorEl(null)}>
                  <ListItem {...child} isChild />
                </Box>
              </Link>
            ))}
          </Box>
        </Popover>
      ) : null}
    </>
  );
}
